(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/get-eid-link.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/get-eid-link.js');
'use strict';

const {
  ReactIcon: Icon
} = svs.ui;
const {
  loginType
} = svs.playerLoginReact.constants;
const GetEidLink = () => {
  const isBankId = ReactRedux.useSelector(state => state.playerloginreact.playerLoginType) === loginType.BANKID;
  const href = isBankId ? 'https://www.bankid.com/privat/skaffa-bankid/' : 'https://frejaeid.com/skaffa-freja-eid/';
  const text = isBankId ? 'Skaffa BankID' : 'Skaffa Freja eID';
  return React.createElement("div", {
    className: "align-right u-flex-grow-1"
  }, React.createElement("span", {
    className: "login-react-hover text-align-right"
  }, React.createElement("a", {
    href: href
  }, React.createElement("span", {
    className: "f-bold fc-navy u-text-decoration-underline"
  }, text), React.createElement(Icon, {
    className: "margin-left",
    icon: "external_link",
    size: "200"
  }))));
};
svs.playerLoginReact.sharedComponents.GetEidLink = GetEidLink;

 })(window);